import { Popover as BasePopover } from "@base-ui/react/popover";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { ColorPickerPortalProps } from "./ColorPicker.types";

export function ColorPickerPortal({
  children,
  ...props
}: ColorPickerPortalProps) {
  const container = useFloatingPortalContainer();

  return (
    <BasePopover.Portal
      data-slot="color-picker-portal"
      container={container}
      {...props}
    >
      {children}
    </BasePopover.Portal>
  );
}
